import PropTypes from 'prop-types';
import React from 'react';

import { CommonIcons } from 'common-src/assets/Icons';

import { SmallCaps } from '../Visit';
import styles from './TaskTableHeader.module.scss';

const SORTABLE_COLUMNS = [
  { key: 'status', label: 'Status', cellClass: styles.status },
  { key: 'priority', label: 'Priority', cellClass: styles.priority },
  { key: 'due', label: 'Due', cellClass: styles.due },
];

const TaskTableHeader = ({ lead, sortKey, sortDirection, onSort, className }) => (
  <div className={[styles.header, className].filter(Boolean).join(' ')}>
    {lead ? <span className={styles.lead}>{lead}</span> : null}
    <SmallCaps className={styles.task}>Task</SmallCaps>
    {SORTABLE_COLUMNS.map(({ key, label, cellClass }) => (
      <SmallCaps key={key} className={`${styles.cell} ${cellClass}`}>
        {onSort ? (
          <button
            type="button"
            onClick={() => onSort(key)}
            className={`${styles.sortButton} ${sortKey === key ? styles.sortActive : ''}`}
          >
            {label}
            <img
              className={styles.sortIcon}
              style={{
                transform: sortKey === key && sortDirection === 'asc' ? 'rotate(-180deg)' : 'none',
              }}
              src={CommonIcons.sortDownIcon}
              alt={sortKey === key ? `sort-${sortDirection}` : 'sort'}
            />
          </button>
        ) : (
          label
        )}
      </SmallCaps>
    ))}
  </div>
);

TaskTableHeader.propTypes = {
  lead: PropTypes.node,
  sortKey: PropTypes.string,
  sortDirection: PropTypes.string,
  onSort: PropTypes.func,
  className: PropTypes.string,
};

export default TaskTableHeader;
